import { useEffect, useState } from 'react'
import MoodHistory from '../components/MoodHistory'
import '../styles/tracker-history.css'
import moodData from "../assets/data/moodData"

const TrackerHistory = () => {
  const [pastWeek, setPastWeek] = useState([])
  
  useEffect(() => {
    const today = new Date()
    const weekArr = []

    for (let i = 6; i >= 0; i--) {
      const date = new Date()
      date.setHours(0,0,0,0)
      date.setDate(today.getDate() - i)

      weekArr.push(date)
    }
    setPastWeek(weekArr)
  }, [])

  const mappedMoods = moodData.map(mood => (
    <MoodHistory key={mood.mood} {...mood} pastWeek={pastWeek} />
  ))

  return (
    <div>
      <h2>Your Emotional Journey</h2>
      <p>Emotions ebb and flow - tracking them over time can help you recognize patterns, build self-awareness, and celebrate growth. Every feeling has a place in your story.</p>
      <section className='history-container'>
        {mappedMoods}
      </section>
    </div>
  )
}

export default TrackerHistory